import axios from 'axios';

import mprAxiosInstance from '../axios';

export const unlockPolicyPBE = async (
  policyNumber: string,
  custKey: string,
  mdmId?: string
) => {
  const data = await axios.delete(
    `${
      import.meta.env.VITE_LEGACY_ENDORSEMENT_URL
    }/api/v3/endorsement/${custKey}/policies/${policyNumber}/lock`,
    {
      headers: {
        Authorization:
          mprAxiosInstance.defaults.headers.common['Authorization'],
        DIRECTACCESS: 'false',
        DIRECTACCESSID: custKey,
        mdmId,
      },
    }
  );
  return data;
};
